import { useState } from 'react'
import {
  EMAIL,
  EMAIL_PLACEHOLDER,
  EMAIL_VALIDATION_MESSAGE,
} from '../../constants/ui.labels'
import Box from '@talkdesk/cobalt-react-box'
import Label from '@talkdesk/cobalt-react-label'
import { Group, GroupItem } from '@talkdesk/cobalt-react-input-group'
import Input from '@talkdesk/cobalt-react-input'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'
import Flex from '@talkdesk/cobalt-react-flex'
import IconWithProvider from '@talkdesk/cobalt-react-icon'
import { Text } from '@talkdesk/cobalt-react-typography'

const PasswordResetForm = ({
  onEmailValidation,
  email,
  onEmailChange,
  disabledForm = false,
}) => {
  const theme = useTheme()
  const [isValid, setIsValid] = useState(true)
  const onChange = ({ target }) => {
    onEmailChange({ target })
    setIsValid(onEmailValidation(target.value))
  }

  return (
    <Box>
      <Box paddingY='2'>
        <Label htmlFor='password-reset-email'>{EMAIL}</Label>
      </Box>
      <Group isDisabled={disabledForm} isInvalid={!isValid}>
        <GroupItem>
          <Input
            id='password-reset-email'
            placeholder={EMAIL_PLACEHOLDER}
            type='email'
            variation='unstyled'
            autoFocus
            onChange={onChange}
            value={email}
          />
        </GroupItem>
      </Group>
      {!isValid && (
        <Box paddingTop='1'>
          <Flex alignY='center' gap='2'>
            <IconWithProvider
              size='small'
              name='error_outline'
              color={theme.red500}
            />
            <Text size='small' color={theme.red500}>
              {EMAIL_VALIDATION_MESSAGE}
            </Text>
          </Flex>
        </Box>
      )}
    </Box>
  )
}

export default PasswordResetForm
